/**
 * Company finance product-exposure gate (COMPANY-WORKSPACE-H2).
 *
 * Build-time CRA env: REACT_APP_COMPANY_FINANCE_ENABLED
 *
 * Fail-closed semantics:
 *   unset / empty  -> disabled
 *   false          -> disabled
 *   " FALSE "      -> disabled
 *   true           -> enabled
 *   " true "       -> enabled
 *   unknown value  -> disabled
 *
 * Routing/navigation exposure only — not a security boundary.
 * Backend H1 O7/T13 remains authoritative.
 *
 * Production/browser builds must use CRA DefinePlugin substitution of
 * `process.env.REACT_APP_COMPANY_FINANCE_ENABLED` (module-scope capture).
 */

export function parseCompanyFinanceEnabled(rawValue) {
  if (rawValue === undefined || rawValue === null) {
    return false;
  }
  const normalized = String(rawValue).trim().toLowerCase();
  if (normalized === "") {
    return false;
  }
  if (normalized === "true") {
    return true;
  }
  return false;
}

const BUILD_TIME_COMPANY_FINANCE_ENABLED =
  process.env.REACT_APP_COMPANY_FINANCE_ENABLED;

/**
 * @param {object|undefined} [overrideEnv]
 *   Optional explicit env map for tests. When omitted, uses the CRA build-time
 *   value captured above.
 */
export function isCompanyFinanceEnabled(overrideEnv) {
  if (overrideEnv !== undefined) {
    const raw = Object.prototype.hasOwnProperty.call(
      overrideEnv,
      "REACT_APP_COMPANY_FINANCE_ENABLED",
    )
      ? overrideEnv.REACT_APP_COMPANY_FINANCE_ENABLED
      : undefined;
    return parseCompanyFinanceEnabled(raw);
  }
  return parseCompanyFinanceEnabled(BUILD_TIME_COMPANY_FINANCE_ENABLED);
}
